
import { ReactNode } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { cn } from "@/lib/utils";
import { useIsMobile } from "@/hooks/use-mobile";

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const isMobile = useIsMobile();
  
  return (
    <div className="min-h-screen flex flex-col">
      <Sidebar />
      <div className={cn(
        "flex-1 flex flex-col min-h-screen",
        isMobile ? "pl-0" : "pl-64" // Adjust for sidebar width
      )}>
        <Header />
        <main className="flex-1 p-4 sm:p-6 md:p-8 animate-fade-in">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
